import BaseApi from '@lumapps/base-api';

import { LumappsTrackingEvent } from '../types';

const trackingApi = new BaseApi({ path: 'analytics/events', version: BaseApi.versions.v2 });

export interface SendTrackingOptions {
    /** Send the request with the fetch `keepalive` flag so it survives page unload */
    keepalive?: boolean;
}

export const sendTracking = async (event: LumappsTrackingEvent, { keepalive }: SendTrackingOptions = {}) => {
    try {
        return await trackingApi.post('', event, {
            validateStatus: (status: number) => status !== 400,
            ...(keepalive ? { adapter: 'fetch', fetchOptions: { keepalive: true } } : {}),
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        return console.error('An error occurred while sending tracking event', { event, err });
    }
};
